(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["chromatica-home-radar-network"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.querySelector('[data-home-radar]');
  if (!root) return;
  const clock = root.querySelector('[data-home-radar-clock]');
  const syncClock = () => {
    if (!clock) return;
    clock.textContent = new Intl.DateTimeFormat('de-DE',{hour:'2-digit',minute:'2-digit',hour12:false,timeZone:'Europe/Berlin'}).format(new Date()) + ' / BERLIN';
  };
  syncClock();
  setInterval(syncClock,30000);
  if (!('IntersectionObserver' in window)) {
    root.classList.add('is-ready');
    return;
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      root.classList.add('is-ready');
      observer.disconnect();
    });
  }, {threshold:.12});
  observer.observe(root);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["chromatica-radar-map"] && !Shopify.designMode) return;
  try {
    (() => {
  const callIcon='<svg viewBox="0 0 20 20" aria-hidden="true"><circle cx="10" cy="10" r="6"/><circle cx="10" cy="10" r="2"/><path d="M10 1v3M10 16v3M1 10h3M16 10h3"/></svg>';
  const eventIcon='<svg viewBox="0 0 20 20" aria-hidden="true"><rect x="3" y="4" width="14" height="13" rx="2"/><path d="M6 2v4M14 2v4M3 8h14M6 11h3M11 11h3M6 14h3"/></svg>';
  const tileTemplate='https://tile.openstreetmap.org/{z}/{x}/{y}.png';
  const tileSize=256;
  const minZoom=1;
  const maxZoom=18;
  const maxLat=85.05112878;

  document.querySelectorAll('[data-radar-map]').forEach(root => {
    if(root.dataset.mapWired==='1')return;
    root.dataset.mapWired='1';

    const currentRadar=root.dataset.currentRadar;
    const viewport=root.querySelector('[data-radar-map-viewport]');
    const tilesPane=root.querySelector('[data-radar-map-tiles]');
    const markers=root.querySelector('[data-radar-map-markers]');
    const visibleEl=root.querySelector('[data-radar-map-visible]');
    const citiesEl=root.querySelector('[data-radar-map-cities]');
    const notice=root.querySelector('[data-radar-map-notice]');
    const userEl=root.querySelector('[data-radar-map-user]');
    const radius=root.querySelector('[data-radar-map-radius]');
    const nearBtn=root.querySelector('[data-radar-map-near]');
    const cityCard=root.querySelector('[data-radar-map-citycard]');
    const cityName=root.querySelector('[data-radar-map-citycard-city]');
    const citySummary=root.querySelector('[data-radar-map-citycard-summary]');
    const cityList=root.querySelector('[data-radar-map-citycard-list]');
    const enabledKinds=new Set(['open_call','event']);
    const tileNodes=new Map();
    const activePointers=new Map();
    const de=(document.documentElement.lang||'en').toLowerCase().startsWith('de');

    const labels=de?{
      citySignal:'STADT-SIGNAL',calls:'OPEN CALLS',events:'EVENTS',record:'EINTRAG',records:'EINTRÄGE',jump:'ZUM EINTRAG ↓',open:'ÖFFNEN ↗',requesting:'STANDORT WIRD ANGEFRAGT…',denied:'STANDORTFREIGABE NICHT ERTEILT. DIE RADAR MAP FUNKTIONIERT WEITER OHNE STANDORT.',unavailable:'STANDORT IST IN DIESEM BROWSER NICHT VERFÜGBAR.'
    }:{
      citySignal:'CITY SIGNAL',calls:'OPEN CALLS',events:'EVENTS',record:'RECORD',records:'RECORDS',jump:'VIEW RECORD ↓',open:'OPEN RADAR ↗',requesting:'REQUESTING YOUR APPROXIMATE LOCATION…',denied:'LOCATION PERMISSION WAS NOT GRANTED. THE RADAR MAP STILL WORKS WITHOUT IT.',unavailable:'LOCATION IS NOT AVAILABLE IN THIS BROWSER.'
    };

    const view={lat:18,lon:12,zoom:2.2};
    let points=null;
    let initialized=false;
    let currentState=null;
    let user=null;
    let selectedMarker=null;
    let dragStart=null;
    let pinchStart=null;
    let frame=0;

    const clamp=(v,min,max)=>Math.max(min,Math.min(max,v));
    const sameRadar=p=>(currentRadar==='open_calls'&&p.kind==='open_call')||(currentRadar==='events'&&p.kind==='event');
    const targetId=p=>(p.kind==='event'?'event-':'open-call-')+p.handle;
    const worldSize=z=>tileSize*Math.pow(2,z);
    const project=(lat,lon,z)=>{
      const safeLat=clamp(lat,-maxLat,maxLat);
      const size=worldSize(z);
      const x=(lon+180)/360*size;
      const sin=Math.sin(safeLat*Math.PI/180);
      const y=(.5-Math.log((1+sin)/(1-sin))/(4*Math.PI))*size;
      return{x,y};
    };
    const unproject=(x,y,z)=>{
      const size=worldSize(z);
      const lon=x/size*360-180;
      const n=Math.PI-2*Math.PI*y/size;
      const lat=180/Math.PI*Math.atan(Math.sinh(n));
      return{lat:clamp(lat,-maxLat,maxLat),lon:clamp(lon,-180,180)};
    };
    const distance=(a,b)=>{
      const R=6371,toRad=x=>x*Math.PI/180,dLat=toRad(b.lat-a.lat),dLon=toRad(b.lon-a.lon);
      const q=Math.sin(dLat/2)**2+Math.cos(toRad(a.lat))*Math.cos(toRad(b.lat))*Math.sin(dLon/2)**2;
      return 2*R*Math.atan2(Math.sqrt(q),Math.sqrt(1-q));
    };

    const parsePoints=()=>[...root.querySelectorAll('[data-radar-map-point]')].map(el=>{
      const lat=Number(el.dataset.lat),lon=Number(el.dataset.lon);
      if(!Number.isFinite(lat)||!Number.isFinite(lon))return null;
      return{kind:el.dataset.kind,handle:el.dataset.handle,title:el.dataset.title,city:el.dataset.city,country:el.dataset.country,continent:el.dataset.continent,categories:(el.dataset.categories||'').split('|').filter(Boolean),date:el.dataset.date,meta:el.dataset.meta,url:el.dataset.url,lat,lon,key:(el.dataset.city||'')+'|'+(el.dataset.country||'')};
    }).filter(Boolean);

    const matchesState=p=>{
      if(!currentState)return true;
      if(sameRadar(p)&&Array.isArray(currentState.visibleHandles)&&!currentState.visibleHandles.includes(p.handle))return false;
      const s=currentState.shared||{};
      if(s.continent&&p.continent!==s.continent)return false;
      if(s.country&&p.country!==s.country)return false;
      if(s.city&&p.city!==s.city)return false;
      if(s.category&&!p.categories.includes(s.category))return false;
      return true;
    };

    const visiblePoints=()=>(points||[]).filter(p=>{
      if(!enabledKinds.has(p.kind))return false;
      if(!matchesState(p))return false;
      if(user&&distance(user,p)>Number(radius.value||500))return false;
      return true;
    });

    const screenToGeo=(sx,sy,z=view.zoom)=>{
      const center=project(view.lat,view.lon,z);
      return unproject(center.x+(sx-viewport.clientWidth/2),center.y+(sy-viewport.clientHeight/2),z);
    };

    const geoToScreen=(lat,lon,z=view.zoom)=>{
      const center=project(view.lat,view.lon,z);
      const p=project(lat,lon,z);
      let dx=p.x-center.x;
      const size=worldSize(z);
      if(dx>size/2)dx-=size;
      if(dx<-size/2)dx+=size;
      return{x:viewport.clientWidth/2+dx,y:viewport.clientHeight/2+(p.y-center.y)};
    };

    const tileUrl=(z,x,y)=>tileTemplate.replace('{z}',z).replace('{x}',x).replace('{y}',y);

    const renderTiles=()=>{
      const w=viewport.clientWidth,h=viewport.clientHeight;
      if(!w||!h)return;
      const z=clamp(Math.floor(view.zoom),0,19);
      const scale=Math.pow(2,view.zoom-z);
      const n=Math.pow(2,z);
      const size=tileSize*scale;
      const center=project(view.lat,view.lon,z);
      const cx=center.x*scale,cy=center.y*scale;
      const minX=Math.floor((cx-w/2)/size)-1;
      const maxX=Math.floor((cx+w/2)/size)+1;
      const minY=Math.floor((cy-h/2)/size)-1;
      const maxY=Math.floor((cy+h/2)/size)+1;
      const needed=new Set();

      for(let ty=minY;ty<=maxY;ty++){
        if(ty<0||ty>=n)continue;
        for(let tx=minX;tx<=maxX;tx++){
          if(tx<0||tx>=n)continue;
          const key=z+'/'+tx+'/'+ty;
          needed.add(key);
          let img=tileNodes.get(key);
          if(!img){
            img=document.createElement('img');
            img.className='chr-radar-map__tile';
            img.alt='';
            img.decoding='async';
            img.draggable=false;
            img.src=tileUrl(z,tx,ty);
            tileNodes.set(key,img);
            tilesPane.appendChild(img);
          }
          img.style.width=(size+.75)+'px';
          img.style.height=(size+.75)+'px';
          img.style.transform='translate3d('+(tx*size-cx+w/2)+'px,'+(ty*size-cy+h/2)+'px,0)';
        }
      }

      tileNodes.forEach((img,key)=>{
        if(!needed.has(key)){
          img.remove();
          tileNodes.delete(key);
        }
      });
    };

    const closeCity=()=>{
      if(cityCard)cityCard.hidden=true;
      if(selectedMarker)selectedMarker.classList.remove('is-selected');
      selectedMarker=null;
    };

    const positionSignals=()=>{
      markers.querySelectorAll('[data-map-lat][data-map-lon]').forEach(el=>{
        const p=geoToScreen(Number(el.dataset.mapLat),Number(el.dataset.mapLon));
        el.style.left=p.x+'px';
        el.style.top=p.y+'px';
        el.hidden=p.x<-60||p.x>viewport.clientWidth+60||p.y<-60||p.y>viewport.clientHeight+60;
      });
      if(user){
        const p=geoToScreen(user.lat,user.lon);
        userEl.style.left=p.x+'px';
        userEl.style.top=p.y+'px';
        userEl.hidden=false;
      }else userEl.hidden=true;
    };

    const scheduleRender=()=>{
      if(frame)return;
      frame=requestAnimationFrame(()=>{
        frame=0;
        renderTiles();
        positionSignals();
      });
    };

    const flashTarget=target=>{
      target.classList.remove('chr-radar-map-target-flash');
      void target.offsetWidth;
      target.classList.add('chr-radar-map-target-flash');
      window.setTimeout(()=>target.classList.remove('chr-radar-map-target-flash'),2700);
    };

    const jumpLocal=id=>{
      const target=document.getElementById(id);
      if(!target)return false;
      root.open=false;
      requestAnimationFrame(()=>{
        target.scrollIntoView({behavior:'smooth',block:'start'});
        window.setTimeout(()=>flashTarget(target),360);
      });
      return true;
    };

    const goToRecord=p=>{
      const id=targetId(p);
      if(sameRadar(p)&&jumpLocal(id))return;
      window.location.href=p.url;
    };

    const iconMarkup=kind=>kind==='event'?eventIcon:callIcon;

    const showCity=(group,markerEl)=>{
      closeCity();
      selectedMarker=markerEl;
      markerEl.classList.add('is-selected');
      cityList.innerHTML='';
      cityName.textContent=(group[0]?.city||'—')+' / '+(group[0]?.country||'—');
      const calls=group.filter(p=>p.kind==='open_call').length;
      const events=group.filter(p=>p.kind==='event').length;
      const bits=[];
      if(calls)bits.push(calls+' '+labels.calls);
      if(events)bits.push(events+' '+labels.events);
      citySummary.textContent=bits.join(' / ')+' · '+group.length+' '+(group.length===1?labels.record:labels.records);
      root.querySelector('[data-citycard-kicker]').textContent=labels.citySignal;

      group.slice().sort((a,b)=>String(a.date).localeCompare(String(b.date))).forEach(p=>{
        const button=document.createElement('button');
        button.type='button';
        button.className='chr-radar-map__city-record '+(p.kind==='event'?'is-event':'is-call');
        const icon=document.createElement('span');
        icon.className='chr-radar-map__city-record-icon';
        icon.innerHTML=iconMarkup(p.kind);
        const copy=document.createElement('span');
        copy.className='chr-radar-map__city-record-copy';
        const type=document.createElement('small');
        type.textContent=p.kind==='event'?labels.events:labels.calls;
        const title=document.createElement('strong');
        title.textContent=p.title;
        const meta=document.createElement('em');
        meta.textContent=p.meta+(user?' / '+Math.round(distance(user,p))+' KM':'');
        copy.append(type,title,meta);
        const action=document.createElement('span');
        action.className='chr-radar-map__city-record-action';
        action.textContent=sameRadar(p)?labels.jump:labels.open;
        button.append(icon,copy,action);
        button.addEventListener('click',()=>goToRecord(p));
        cityList.appendChild(button);
      });

      cityCard.hidden=false;
      cityCard.scrollTop=0;
    };

    const rebuildSignals=()=>{
      markers.innerHTML='';
      closeCity();
      const vp=visiblePoints();
      const groups=new Map();
      vp.forEach(p=>{
        if(!groups.has(p.key))groups.set(p.key,[]);
        groups.get(p.key).push(p);
      });
      visibleEl.textContent=vp.length;
      citiesEl.textContent=groups.size;

      groups.forEach(group=>{
        const p=group[0];
        let el;
        if(group.length>1){
          const kinds=new Set(group.map(x=>x.kind));
          el=document.createElement('button');
          el.type='button';
          el.className='chr-radar-map__cluster';
          el.textContent=group.length;
          el.dataset.mix=kinds.size>1?'mixed':group[0].kind;
          el.setAttribute('aria-label',group.length+' Radar records in '+p.city);
        }else{
          const item=group[0];
          el=document.createElement('button');
          el.type='button';
          el.className='chr-radar-map__marker';
          el.dataset.kind=item.kind;
          el.innerHTML=iconMarkup(item.kind);
          el.setAttribute('aria-label',(item.kind==='event'?'Event: ':'Open Call: ')+item.title+', '+item.city);
        }
        el.dataset.mapLat=String(p.lat);
        el.dataset.mapLon=String(p.lon);
        el.addEventListener('pointerdown',event=>event.stopPropagation());
        el.addEventListener('click',event=>{event.stopPropagation();showCity(group,el)});
        markers.appendChild(el);
      });

      positionSignals();
    };

    const syncLayerButtons=()=>root.querySelectorAll('[data-radar-map-layer]').forEach(button=>{
      const active=enabledKinds.has(button.dataset.radarMapLayer);
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',active?'true':'false');
    });

    const setView=(lat,lon,zoom)=>{
      view.lat=clamp(lat,-maxLat,maxLat);
      view.lon=clamp(lon,-180,180);
      view.zoom=clamp(zoom,minZoom,maxZoom);
      scheduleRender();
    };

    const zoomAt=(sx,sy,nextZoom)=>{
      const anchor=screenToGeo(sx,sy,view.zoom);
      const z=clamp(nextZoom,minZoom,maxZoom);
      const anchorNew=project(anchor.lat,anchor.lon,z);
      const centerNew={x:anchorNew.x-(sx-viewport.clientWidth/2),y:anchorNew.y-(sy-viewport.clientHeight/2)};
      const centerGeo=unproject(centerNew.x,centerNew.y,z);
      view.lat=centerGeo.lat;
      view.lon=centerGeo.lon;
      view.zoom=z;
      scheduleRender();
    };

    const fitVisible=()=>{
      const vp=visiblePoints();
      if(!vp.length){setView(18,12,2.2);return}
      if(vp.length===1){setView(vp[0].lat,vp[0].lon,8);return}
      const coords=vp.map(p=>project(p.lat,p.lon,0));
      const minX=Math.min(...coords.map(p=>p.x)),maxX=Math.max(...coords.map(p=>p.x));
      const minY=Math.min(...coords.map(p=>p.y)),maxY=Math.max(...coords.map(p=>p.y));
      const spanX=Math.max(1,maxX-minX),spanY=Math.max(1,maxY-minY);
      const usableW=Math.max(200,viewport.clientWidth-120),usableH=Math.max(180,viewport.clientHeight-100);
      const zx=Math.log2(usableW/spanX),zy=Math.log2(usableH/spanY);
      const z=clamp(Math.min(zx,zy,4.2),1.3,4.2);
      const center=unproject((minX+maxX)/2,(minY+maxY)/2,0);
      setView(center.lat,center.lon,z);
    };

    const ensureInit=()=>{
      if(initialized)return;
      try{
        points=parsePoints();
        currentState=window.ChromaticaRadarFilterState?.[currentRadar]||null;
        initialized=true;
      }catch(error){
        points=[];
        initialized=true;
        notice.hidden=false;
        notice.textContent='RADAR MAP DATA COULD NOT BE INITIALIZED. PLEASE RELOAD THE PAGE.';
      }
    };

    root.addEventListener('toggle',()=>{
      if(!root.open){closeCity();return}
      requestAnimationFrame(()=>{
        ensureInit();
        rebuildSignals();
        fitVisible();
        viewport.focus({preventScroll:true});
      });
    });

    root.querySelector('[data-radar-map-close]')?.addEventListener('click',()=>{root.open=false});
    root.querySelector('[data-radar-map-citycard-close]')?.addEventListener('click',closeCity);

    root.querySelectorAll('[data-radar-map-layer]').forEach(button=>button.addEventListener('click',()=>{
      const kind=button.dataset.radarMapLayer;
      if(enabledKinds.has(kind))enabledKinds.delete(kind);else enabledKinds.add(kind);
      syncLayerButtons();
      rebuildSignals();
      scheduleRender();
    }));

    root.querySelector('[data-radar-map-all]')?.addEventListener('click',()=>{
      enabledKinds.add('open_call');enabledKinds.add('event');syncLayerButtons();rebuildSignals();scheduleRender();
    });

    root.querySelector('[data-radar-map-zoom-in]')?.addEventListener('click',()=>zoomAt(viewport.clientWidth/2,viewport.clientHeight/2,view.zoom+1));
    root.querySelector('[data-radar-map-zoom-out]')?.addEventListener('click',()=>zoomAt(viewport.clientWidth/2,viewport.clientHeight/2,view.zoom-1));
    root.querySelector('[data-radar-map-reset]')?.addEventListener('click',()=>{user=null;radius.disabled=true;nearBtn.classList.remove('is-active');enabledKinds.add('open_call');enabledKinds.add('event');syncLayerButtons();rebuildSignals();fitVisible()});

    nearBtn?.addEventListener('click',()=>{
      if(!navigator.geolocation){notice.hidden=false;notice.textContent=labels.unavailable;return}
      notice.hidden=false;
      notice.textContent=labels.requesting;
      navigator.geolocation.getCurrentPosition(pos=>{
        user={lat:pos.coords.latitude,lon:pos.coords.longitude};
        radius.disabled=false;
        nearBtn.classList.add('is-active');
        notice.hidden=true;
        rebuildSignals();
        setView(user.lat,user.lon,8);
      },()=>{notice.textContent=labels.denied},{enableHighAccuracy:false,timeout:8000,maximumAge:300000});
    });

    radius?.addEventListener('change',()=>{rebuildSignals();scheduleRender()});

    viewport.addEventListener('wheel',event=>{
      if(!root.open)return;
      event.preventDefault();
      const rect=viewport.getBoundingClientRect();
      const sx=event.clientX-rect.left,sy=event.clientY-rect.top;
      const delta=clamp(-event.deltaY*.0035,-1.1,1.1);
      zoomAt(sx,sy,view.zoom+delta);
      closeCity();
    },{passive:false});

    viewport.addEventListener('dblclick',event=>{
      if(event.target.closest('button,select,.chr-radar-map__citycard'))return;
      event.preventDefault();
      const rect=viewport.getBoundingClientRect();
      zoomAt(event.clientX-rect.left,event.clientY-rect.top,view.zoom+1.4);
      closeCity();
    });

    const localPointer=event=>{
      const rect=viewport.getBoundingClientRect();
      return{x:event.clientX-rect.left,y:event.clientY-rect.top,clientX:event.clientX,clientY:event.clientY};
    };

    const beginPinch=()=>{
      const arr=[...activePointers.values()];
      if(arr.length<2)return;
      const a=arr[0],b=arr[1];
      const mx=(a.x+b.x)/2,my=(a.y+b.y)/2;
      pinchStart={distance:Math.max(1,Math.hypot(b.x-a.x,b.y-a.y)),zoom:view.zoom,anchor:screenToGeo(mx,my,view.zoom)};
      dragStart=null;
    };

    viewport.addEventListener('pointerdown',event=>{
      if(event.target.closest('button,select,.chr-radar-map__citycard'))return;
      closeCity();
      viewport.focus({preventScroll:true});
      viewport.setPointerCapture(event.pointerId);
      activePointers.set(event.pointerId,localPointer(event));
      viewport.classList.add('is-dragging');
      if(activePointers.size===1){dragStart={clientX:event.clientX,clientY:event.clientY,center:project(view.lat,view.lon,view.zoom)};pinchStart=null}
      else if(activePointers.size===2)beginPinch();
    });

    viewport.addEventListener('pointermove',event=>{
      if(!activePointers.has(event.pointerId))return;
      activePointers.set(event.pointerId,localPointer(event));

      if(activePointers.size>=2&&pinchStart){
        const arr=[...activePointers.values()],a=arr[0],b=arr[1];
        const dist=Math.max(1,Math.hypot(b.x-a.x,b.y-a.y));
        const mx=(a.x+b.x)/2,my=(a.y+b.y)/2;
        const z=clamp(pinchStart.zoom+Math.log2(dist/pinchStart.distance),minZoom,maxZoom);
        const anchorNew=project(pinchStart.anchor.lat,pinchStart.anchor.lon,z);
        const centerNew={x:anchorNew.x-(mx-viewport.clientWidth/2),y:anchorNew.y-(my-viewport.clientHeight/2)};
        const geo=unproject(centerNew.x,centerNew.y,z);
        view.lat=geo.lat;view.lon=geo.lon;view.zoom=z;scheduleRender();return;
      }

      if(activePointers.size===1&&dragStart){
        const x=dragStart.center.x-(event.clientX-dragStart.clientX);
        const y=dragStart.center.y-(event.clientY-dragStart.clientY);
        const geo=unproject(x,y,view.zoom);
        view.lat=geo.lat;view.lon=geo.lon;scheduleRender();
      }
    });

    const endPointer=event=>{
      activePointers.delete(event.pointerId);
      if(activePointers.size===0){dragStart=null;pinchStart=null;viewport.classList.remove('is-dragging');return}
      if(activePointers.size===1){
        const p=[...activePointers.values()][0];
        dragStart={clientX:p.clientX,clientY:p.clientY,center:project(view.lat,view.lon,view.zoom)};
        pinchStart=null;
      }else beginPinch();
    };

    viewport.addEventListener('pointerup',endPointer);
    viewport.addEventListener('pointercancel',endPointer);
    viewport.addEventListener('lostpointercapture',event=>{if(activePointers.has(event.pointerId))endPointer(event)});

    viewport.addEventListener('keydown',event=>{
      const center=project(view.lat,view.lon,view.zoom);
      const step=90;
      let handled=true;
      if(event.key==='ArrowLeft')center.x-=step;
      else if(event.key==='ArrowRight')center.x+=step;
      else if(event.key==='ArrowUp')center.y-=step;
      else if(event.key==='ArrowDown')center.y+=step;
      else if(event.key==='+'||event.key==='='){zoomAt(viewport.clientWidth/2,viewport.clientHeight/2,view.zoom+1);event.preventDefault();return}
      else if(event.key==='-'||event.key==='_'){zoomAt(viewport.clientWidth/2,viewport.clientHeight/2,view.zoom-1);event.preventDefault();return}
      else if(event.key==='0'){fitVisible();event.preventDefault();return}
      else handled=false;
      if(handled){
        event.preventDefault();
        const geo=unproject(center.x,center.y,view.zoom);
        setView(geo.lat,geo.lon,view.zoom);
      }
    });

    window.addEventListener('resize',()=>{if(root.open)requestAnimationFrame(()=>scheduleRender())});
    window.addEventListener('chromatica:radar-filter',event=>{
      if(event.detail?.radar!==currentRadar)return;
      currentState=event.detail;
      if(root.open&&initialized){rebuildSignals();scheduleRender()}
    });

    if(de){
      root.querySelector('[data-map-kicker]').textContent='GLOBALE DISCOVERY-EBENE';
      root.querySelector('[data-map-title]').textContent='EVENTS + OPEN CALLS AUF DER KARTE ENTDECKEN.';
      root.querySelector('[data-map-copy]').textContent='Entdecke die Städte hinter beiden Radar-Systemen. Die Karte zeigt bewusst nur Städte; genaue Orte bleiben in den verifizierten Einträgen.';
      root.querySelector('[data-map-open-label]').textContent='KARTE ÖFFNEN →';
      root.querySelector('[data-map-near-label]').textContent='IN MEINER NÄHE';
      root.querySelector('[data-map-visible-label]').textContent='EINTRÄGE';
      root.querySelector('[data-map-cities-label]').textContent='STÄDTE';
    }

    syncLayerButtons();

    const hash=decodeURIComponent(window.location.hash.slice(1));
    if(/^(event-|open-call-)/.test(hash)){
      window.setTimeout(()=>{
        const target=document.getElementById(hash);
        if(target){
          target.scrollIntoView({behavior:'smooth',block:'start'});
          window.setTimeout(()=>flashTarget(target),320);
        }
      },220);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["chromatica-to-top"] && !Shopify.designMode) return;
  try {
    (() => {
  const button = document.querySelector('[data-chr-global-to-top]');
  if (!button) return;

  const pageWrapper = document.querySelector('.page-wrapper');
  const rootScroller = document.scrollingElement || document.documentElement;

  const getScrollTop = () => {
    const wrapperTop = pageWrapper ? pageWrapper.scrollTop : 0;
    return Math.max(wrapperTop, window.scrollY || 0, rootScroller?.scrollTop || 0);
  };

  const syncState = () => {
    button.classList.toggle('has-scrolled', getScrollTop() > 120);
  };

  syncState();
  window.addEventListener('scroll', syncState, { passive: true });
  pageWrapper?.addEventListener('scroll', syncState, { passive: true });

  button.addEventListener('click', () => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const behavior = reduce ? 'auto' : 'smooth';

    if (pageWrapper) pageWrapper.scrollTo({ top: 0, left: 0, behavior });
    if (rootScroller) rootScroller.scrollTo({ top: 0, left: 0, behavior });
    window.scrollTo({ top: 0, left: 0, behavior });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
